/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface CountriesResponse {

        "countries"?: Array<Country>;
    }

}
